module.exports = __webpack_public_path__ + "./images/26850b5661a2a4f39f4b60e31a0f0891.jpg";